module.exports = __webpack_public_path__ + "img/facebook.58b009fb.png";